module.exports = __webpack_public_path__ + "img/AL8000-3.fdbc5d59.jpg";